import { render } from "./RollRecentElement.vue?vue&type=template&id=2b378cb5&scoped=true"
import script from "./RollRecentElement.vue?vue&type=script&lang=js"
export * from "./RollRecentElement.vue?vue&type=script&lang=js"

import "./RollRecentElement.vue?vue&type=style&index=0&id=2b378cb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b378cb5"]])

export default __exports__